import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR
} from "./actionTypes";

export const userChangePassword = (username, user, pass, token, history) => {
  return {
    type: CHANGE_PASSWORD,
    payload: { username, user, pass, token, history }
  };
};

export const userChangePasswordSuccess = message => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: message
  };
};

export const userChangePasswordError = message => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: message
  };
};
